import React from "react";
import MetricCard from "./MetricCard";
import SectionPanel from "./SectionPanel";
import InfoModal from "./InfoModal";
import { partialImprovementInfo } from "../analyticsInfoContent";
import { COLORS } from "../mockData";

const formatRows = (rows = []) =>
  rows.map((r) => ({
    label: r.label,
    value:
      r.percentage !== undefined ? `${r.value} (${r.percentage}%)` : r.value,
  }));

const PartialResponse = ({ data, loading, onCardClick }) => {
  const section = data?.partialResponse;
  const cards = section?.cards || [];

  if (!cards.length && !loading) return null;

  return (
    <SectionPanel
      title={section?.title || "Partial Response (≥50% Reduction)"}
      titleAddon={<InfoModal {...partialImprovementInfo} />}
    >
      <div className="analytics-card-pair">
        {cards.map((card, i) => (
          <MetricCard
            key={i}
            label={card.label}
            period={card.timeRange}
            mainValue={card.displayValue}
            accentColor={card.label === "PHQ-9" ? COLORS.phq9 : COLORS.gad7}
            labelColor={
              card.label === "PHQ-9" ? COLORS.phq9Label : COLORS.gad7Label
            }
            rows={formatRows(card.rows)}
            onClick={
              onCardClick
                ? () =>
                    onCardClick({
                      cardType: "partialResponse",
                      assessmentType: card.label === "PHQ-9" ? "phq9" : "gad7",
                      timeRange: card.timeRange,
                      sectionTitle: section?.title || "Partial Response (≥50% Reduction)",
                      cardLabel: card.label,
                    })
                : undefined
            }
          />
        ))}
      </div>
    </SectionPanel>
  );
};

export default PartialResponse;
